import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDeleteLegalClientBodyMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

interface Args {
  id: string;
  reason: string;
  versionNumber: number;
}

export const useDeleteLegalClientBody = () => {
  const [handle, { loading, error: apolloError }] =
    useDeleteLegalClientBodyMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    deleteLegalClientBody: useCallback(
      async (input: Args) => {
        const res = await handle({ variables: input });
        return res.data?.deleteLegalClientBody;
      },
      [handle]
    ),
  };
};
